module.exports = __webpack_public_path__ + "static/media/tyre-yellow-two3.75af920c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-yellow-two3.png
// module id = 357
// module chunks = 0